/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ReportMarketingMessageViewedRequest} from '@cash-web/protos/squareup/cash/local/client/app/v1/cash_app_local_client_app_service.pb'
import {ReportMarketingMessageViewedResponse} from '@cash-web/protos/squareup/cash/local/client/app/v1/cash_app_local_client_app_service.pb'


export const reportMarketingMessageViewed = (request: ReportMarketingMessageViewedRequest, options?: CashRequestOptions) => post<ReportMarketingMessageViewedRequest, ReportMarketingMessageViewedResponse>("/2.0/cash/report-marketing-message-viewed", request, {...options, rejectOnError: true })